import React from "react";
import Box from "react-raster";
import styled, { createGlobalStyle } from "styled-components";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import Container from "../Container";
import { Media } from "../Media";
import { H2, Copy, StyledList, Eyebrow, richTextOptions } from "../Typography";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const AnimationKeyFrames = createGlobalStyle`
  @keyframes fadeInAnimation { 
    0% { 
      opacity: 0;
      transform: translateY(100px);
    } 
    100% { 
      opacity: 1;
      transform: translateY(0);
    } 
  }
`;

const DesktopContainer = styled(Container)`
  align-content: center;
`;

const Description = styled.div`
  margin-bottom: 55px;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
`;

function HasImage({
  eyebrow,
  title,
  description,
  capabilities,
  image,
  anchorId,
}) {
  return (
    <>
      <AnimationKeyFrames />
      <Media lessThan="l">
        <Container id={anchorId}>
          <Box cols={[6, 12]}>
            {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
            <H2>{title}</H2>
            {description && (
              <Description>
                <Copy>{description}</Copy>
              </Description>
            )}
            {capabilities && (
              <StyledList>
                {renderRichText(capabilities, richTextOptions)}
              </StyledList>
            )}
            <ImageContainer>
              <GatsbyImage image={getImage(image)} alt={image.description} />
            </ImageContainer>
          </Box>
        </Container>
      </Media>
      <Media greaterThanOrEqual="l">
        <DesktopContainer id={anchorId}>
          <Box cols={6} alignItems="center">
            <GatsbyImage image={getImage(image)} alt={image.description} />
          </Box>
          <Box cols={6}>
            <Box cols={5} marginRight={1} marginBottom={0.75}>
              {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
              <H2>{title}</H2>
              {description && <Copy>{description}</Copy>}
            </Box>
            <Box cols={6}>
              {capabilities && (
                <StyledList $columnsAt="l">
                  {renderRichText(capabilities, richTextOptions)}
                </StyledList>
              )}
            </Box>
          </Box>
        </DesktopContainer>
      </Media>
    </>
  );
}

export default HasImage;
